import styled from 'styled-components';
import { baseVariables } from '../../styles/baseVariables';

const { spacers } = baseVariables;

const sharedStyles = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Wrapper = styled.button`
  ${sharedStyles}
  background: none;
  border: none;
  padding: ${spacers?.spacers?.[1] ?? '0.25rem'};
`;

export const AnchorWrapper = styled.a`
  ${sharedStyles}
  text-decoration: none;
  color: inherit;
  padding: ${spacers?.spacers?.[1] ?? '0.25rem'};
`;
